import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import { UtilsService } from '../../core/services/utils/utils.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    standalone: false
})
export class HomeComponent implements OnInit {
  loading = true;
  count: any = {};
  categories: any[] = [];
  recentReviews: any[] = [];
  latestEntities: any[] = [];
  trendData: any;
  trendOptions: any;
  usersDoughnutData: any;
  usersDoughnutOptions: any;

  constructor(
    private dashboardService: DashboardService,
    private utils: UtilsService
  ) { }

  ngOnInit(): void {
    this.instantiateCharts();
    this.loadDashboard();
  }

  instantiateCharts(): void {
    this.trendOptions = {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        position: 'top',
        labels: {
          boxWidth: 14,
        },
      },
      title: {
        display: false,
      },
      scales: {
        yAxes: [
          {
            display: true,
            ticks: {
              beginAtZero: true,
              precision: 0,
            }
          }
        ],
        xAxes: [
          {
            ticks: {
              display: true,
            }
          }
        ]
      }
    };

    this.usersDoughnutOptions = {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        position: 'bottom',
      },
      cutoutPercentage: 65,
    };
  }

  loadDashboard(): void {
    this.loading = true;
    this.dashboardService.dashboardOverview().subscribe((res) => {
      const data = res?.response || {};
      const kpis = data?.kpis || {};
      const trend = data?.reviewTrend || {};
      this.categories = data?.topCategories || [];
      this.recentReviews = data?.recentReviews || [];
      this.latestEntities = data?.latestEntities || [];

      this.count = {
        totalUsers: kpis?.totalUsers || 0,
        totalBhakts: kpis?.totalBhakts || 0,
        totalEntities: kpis?.totalEntities || 0,
        totalCategories: kpis?.totalCategories || 0,
        totalRatings: kpis?.totalRatings || 0,
        ratingsLast24h: kpis?.ratingsLast24h || 0,
        totalNews: kpis?.totalNews || 0,
      };

      const bhaktsTrend = trend?.bhakts || [];
      const legacyVishwagurusTrend = trend?.vishwagurus || [];
      const totalTrend = (trend?.total?.length ? trend.total : this.sumSeries(bhaktsTrend, legacyVishwagurusTrend));

      this.trendData = {
        labels: trend?.labels || [],
        datasets: [
          {
            label: 'Bhakts',
            data: bhaktsTrend,
            borderColor: '#0EA5A4',
            backgroundColor: 'rgba(14,165,164,0.08)',
            fill: true,
            pointRadius: 3,
            borderWidth: 2,
          },
          {
            label: 'Total Reviews',
            data: totalTrend,
            borderColor: '#F97316',
            backgroundColor: 'rgba(249,115,22,0.08)',
            fill: true,
            pointRadius: 3,
            borderWidth: 2,
          }
        ]
      };

      this.usersDoughnutData = {
        labels: ['Entities', 'Categories', 'News Posts'],
        datasets: [
          {
            data: [this.count.totalEntities, this.count.totalCategories, this.count.totalNews],
            backgroundColor: ['#0EA5A4', '#F97316', '#6366F1'],
            hoverBackgroundColor: ['#14b8a6', '#fb923c', '#818cf8'],
          }
        ]
      };

      this.loading = false;
    }, err => {
      this.loading = false;
      this.utils.resErr(err);
      this.trendData = {
        labels: [],
        datasets: [],
      };
      this.usersDoughnutData = {
        labels: [],
        datasets: [],
      };
    });
  }

  private sumSeries(primary: number[] = [], secondary: number[] = []): number[] {
    const length = Math.max(primary.length, secondary.length);
    return Array.from({length}, (_, i) => (primary[i] || 0) + (secondary[i] || 0));
  }
}
